import { Table, TableBody, TableCell, TableContainer, TableHead, TableRow, TextField, Toolbar, } from '@mui/material'
import makeStyles from '@mui/styles/makeStyles'
import React, { useEffect, useState } from 'react'
import { useParams } from 'react-router'
import { formatNumber } from '../utils/numbersFormatter'
import { useTranslation } from 'react-i18next'
import { ClientCashflow, ClientTaxPosition, ClientTaxPositionDeal, ClientTaxPositionDealTmp } from '../redux/reducers/clients'
import { NewLayout } from '../components/newLayout/NewLayout'
import { newThemeObject } from '../newTheme'
import { OrderDetailDialog } from '../components/dialogs/OrderDetailDialog'
import { FileImportDialog } from '../components/dialogs/FileImportDialog'
import CardWrapper from '../components/common/CardWrapper'
import classNames from 'classnames'
import { useSelector } from '../redux/hooks/useSelector'
import { LoadingIndicator } from '../components/common/LoadingIndicator'
import { useClientApi } from '../hooks/useClientApi'
import { getClientIdFromUser, isClientUser } from '../services/keycloak.service'
import { DatePicker, LocalizationProvider } from '@mui/lab'
import AdapterDateFns from '@date-io/date-fns'
import { ColoredIconButton } from '../components/common/ColoredIconButton'
import DownloadIcon from '@mui/icons-material/Download';
import { AlertMessageConfirmation } from '../components/dialogs/AlertMessageConfirmation'

const useStyles = makeStyles(theme => ({
  title: {
    color: newThemeObject.palette.main.primary,
    margin: 0,
  },
  paper: {
    overflowY: 'auto',
    overflowX: 'auto',
    gap: theme.spacing(2),
    display: 'flex',
    flexDirection: 'column',
    marginBottom: '20px',
  },
  topBar: {
    margin: '0.2rem 2rem',
    display: 'flex',
    justifyContent: 'space-between',
    fontSize: '1.2rem',
    fontWeight: 600,
  },
  table: {
    minWidth: 1000,
  },
  tableHead: {
    ...newThemeObject.table.tableHead,
  },
  tableHeadChildrenText: {
    ...newThemeObject.table.tableHeadChildrenText,
  },
  tableHeadChildren: {
    ...newThemeObject.table.tableHeadChildren,
  },
  tableHeadChildrenFirst: {
    ...newThemeObject.table.tableHeadChildrenFirst,
  },
  tableHeadChildrenLast: {
    ...newThemeObject.table.tableHeadChildrenLast,
  },
  tableContent: {
    ...newThemeObject.table.tableContent,
  },
  tableContentFirst: {
    ...newThemeObject.table.tableContentFirst,
  },
  lastRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },
  tableRow: {
    '& .MuiTableCell-root': {
      borderBottom: 'none',
      borderTop: 'thin solid',
      borderColor: 'rgba(0, 0, 0, 0.12)',
    },
  },
  text: {
    fontWeight: '400',
    margin: '0',
    fontSize: '0.7rem',
    textWrap: 'wrap',
  },

  tableToolBar: {
    minHeight: 0,
    display: 'flex',
    alignContent: 'space-around',
    width: '100%',
    padding: 0,
    paddingBottom: 20,
    margin: 0,
    flexDirection: 'column',
    [theme.breakpoints.up('md')]: {
      flexDirection: 'row',
    },
  },
  textField: {
    width: '100%',
    marginTop: theme.spacing(1.5),
    [theme.breakpoints.up('md')]: {
      marginTop: 0,
      marginRight: theme.spacing(1.5),
      maxWidth: '180px',
    },
  },
  filler: {
    flexGrow: 1,
  },
  icon: {
    color: newThemeObject.palette.main.sectext,
    backgroundColor: '#ffffff',
  },
  firstClickableRow: {
    cursor: 'pointer',
    '& .MuiTableCell-root': {
      borderBottom: 'none',
    },
  },

}))

export const ClientDetailTaxPosition = () => {
  const classes = useStyles()

  const loading = useSelector(state => state.clients.loading)
  const client = useSelector(state => state.clients.client)
  const clientTaxPositionsTmp = useSelector(state => state.clients.clientTaxPosition)

  const { getClientTaxPosition, exportPosition } = useClientApi()
  const { getClient } = useClientApi()
  const { clientId } = useParams<{ clientId: string }>()
  const { t } = useTranslation()

  const getClientId = () => {
    if (isClientUser()) {
      return getClientIdFromUser()
    } else {
      return clientId
    }
  }
  
  const clientId2 = getClientId()
  useEffect(()=>{
    if ( !client ) {
      getClient(Number(clientId2))
    }
    if ( client && client.clientId!==0 ) {
      getClientTaxPosition(client.clientId);
    }
  }, [client])

  const [dateFrom, setDateFrom] = useState<Date>();
  const [dateTo, setDateTo] = useState<Date>();
  const [search, setSearch] = useState<string>();

  const [clientTaxPositions, setClientTaxPositions] = useState<ClientTaxPositionDealTmp[]>([]);
  const [clientTaxOtherOperations, setClientTaxOtherOperations] = useState<ClientCashflow[]>([]);
  const [clientTaxWithholdingTaxes, setClientTaxWithholdingTaxes] = useState<ClientCashflow[]>([]);

  const onDateFromChange = (name: string) => (date: Date | null) => {
    setDateFrom(date || undefined)
  }

  const onDateToChange = (name: string) => (date: Date | null) => {
    setDateTo(date || new Date())
  }

  const onOrderTypeSearchChange = (event: React.ChangeEvent<{ value: string }>) => {
    setSearch(event.target.value)
  }

  const [showConfirmation, setShowConfirmation] = useState<boolean>(false);

  const handleConfirmation = () => {
    exportPosition({deals: clientTaxPositions, withholdingTaxes: clientTaxOtherOperations, otherOperations:clientTaxWithholdingTaxes}, clientId, dateFrom ? dateFrom.toISOString() : '', dateTo ? dateTo.toISOString():'');
    setShowConfirmation(false);
  }

  const handleCloseConfirmation = () => {
    setShowConfirmation(false);
  }

  useEffect(()=>{
    if ( clientTaxPositionsTmp && clientTaxPositionsTmp.deals ) {
      if ( clientTaxPositionsTmp.deals && clientTaxPositionsTmp.deals.length === 0 ) {
        setClientTaxPositions([]);
      } else {
        let tmp: ClientTaxPositionDealTmp[] = [];
        for (let i=0; i<clientTaxPositionsTmp.deals.length; i++) {
          if ( clientTaxPositionsTmp.deals[i].sells && clientTaxPositionsTmp.deals[i].sells.length > 0 ) {
            if ( dateFrom || dateTo || search ) {
              for ( let j=0; j<clientTaxPositionsTmp.deals[i].sells.length; j++) {
                if ( 
                  ( dateFrom && dateTo && new Date(clientTaxPositionsTmp.deals[i].sells[j].tradeDate) >= dateFrom && new Date(clientTaxPositionsTmp.deals[i].sells[j].tradeDate) <= dateTo ) ||
                  ( dateFrom && !dateTo && new Date(clientTaxPositionsTmp.deals[i].sells[j].tradeDate) >= dateFrom ) || 
                  ( !dateFrom && dateTo && new Date(clientTaxPositionsTmp.deals[i].sells[j].tradeDate) <= dateTo ) || 
                  ( search && clientTaxPositionsTmp.deals[i].sells[j].isin && clientTaxPositionsTmp.deals[i].sells[j].isin.toLowerCase().includes(search.toLowerCase()) )
                ) {
                  tmp.push(clientTaxPositionsTmp.deals[i]);
                  break;
                }
              }
            } else {
              tmp.push(clientTaxPositionsTmp.deals[i]);
            }
          }
        }
        setClientTaxPositions(tmp);
      }
    }
    if ( clientTaxPositionsTmp && clientTaxPositionsTmp.otherOperations ) {
      if ( clientTaxPositionsTmp.otherOperations && clientTaxPositionsTmp.otherOperations.length === 0 ) {
        setClientTaxOtherOperations([]);
      } else {
        let tmp: ClientCashflow[] = [];
        if ( dateFrom || dateTo || search ) {
          for (let i=0; i<clientTaxPositionsTmp.otherOperations.length; i++) {
            if ( 
              ( dateFrom && dateTo && new Date(clientTaxPositionsTmp.otherOperations[i].tradeDate) >= dateFrom && new Date(clientTaxPositionsTmp.otherOperations[i].tradeDate) <= dateTo ) ||
              ( dateFrom && !dateTo && new Date(clientTaxPositionsTmp.otherOperations[i].tradeDate) >= dateFrom ) || 
              ( !dateFrom && dateTo && new Date(clientTaxPositionsTmp.otherOperations[i].tradeDate) <= dateTo ) || 
              ( search && clientTaxPositionsTmp.otherOperations[i].text && clientTaxPositionsTmp.otherOperations[i].text.toLowerCase().includes(search.toLowerCase()) )
            ) {
              tmp.push(clientTaxPositionsTmp.otherOperations[i]);
              break;
            }
          }
        } else {
          tmp = [...clientTaxPositionsTmp.otherOperations];
        }
        setClientTaxOtherOperations(tmp);
      }
    }
    if ( clientTaxPositionsTmp && clientTaxPositionsTmp.withholdingTaxes ) {
      if ( clientTaxPositionsTmp.withholdingTaxes && clientTaxPositionsTmp.withholdingTaxes.length === 0 ) {
        setClientTaxWithholdingTaxes([]);
      } else {
        let tmp: ClientCashflow[] = [];
        if ( dateFrom || dateTo || search ) {
          for (let i=0; i<clientTaxPositionsTmp.withholdingTaxes.length; i++) {
            if ( 
              ( dateFrom && dateTo && new Date(clientTaxPositionsTmp.withholdingTaxes[i].tradeDate) >= dateFrom && new Date(clientTaxPositionsTmp.withholdingTaxes[i].tradeDate) <= dateTo ) ||
              ( dateFrom && !dateTo && new Date(clientTaxPositionsTmp.withholdingTaxes[i].tradeDate) >= dateFrom ) || 
              ( !dateFrom && dateTo && new Date(clientTaxPositionsTmp.withholdingTaxes[i].tradeDate) <= dateTo ) || 
              ( search && clientTaxPositionsTmp.withholdingTaxes[i].text && clientTaxPositionsTmp.withholdingTaxes[i].text.toLowerCase().includes(search.toLowerCase()) )
            ) {
              tmp.push(clientTaxPositionsTmp.withholdingTaxes[i]);
              break;
            }
          }
        } else {
          tmp = [...clientTaxPositionsTmp.withholdingTaxes];
        }
        setClientTaxWithholdingTaxes(tmp);
      }
    }
  }, [clientTaxPositionsTmp, dateFrom, dateTo, search])

  return (
    <NewLayout pageName="TAX_REPORT_TRANSACTION">

      <Toolbar variant="dense" className={classes.tableToolBar}>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            renderInput={params => <TextField {...params} variant="standard" className={classes.textField} label={t('DATE_FROM2')}/>}
            inputFormat="dd/MM/yyyy"
            value={dateFrom || null}
            onChange={onDateFromChange('dateFromId')}
          />
        </LocalizationProvider>
        <LocalizationProvider dateAdapter={AdapterDateFns}>
          <DatePicker
            renderInput={params => (
              <TextField {...params} variant="standard" className={classes.textField} label={t('DATE_TO')} />
            )}
            inputFormat="dd/MM/yyyy"
            value={dateTo || null}
            onChange={onDateToChange('dateToId')}
          />
        </LocalizationProvider>

        <TextField
          variant="standard"
          className={classes.textField}
          placeholder={t('SEARCH')}
          label={t('SEARCH')}
          onChange={onOrderTypeSearchChange}
          value={search}
        />

        <div style={{'paddingTop': '18px', 'marginLeft': 'auto'}} >
          <ColoredIconButton
              className={classes.icon}
              onClick={() => {
                setShowConfirmation(true);
              }}
              size="small"
              icon={<DownloadIcon />}
          />
        </div>
      </Toolbar>

      {loading && <LoadingIndicator />}
      {!loading && clientTaxPositions && clientTaxPositions.length > 0 &&
        clientTaxPositions.map((position: ClientTaxPositionDealTmp, securityIndex: number) => (
          <React.Fragment key={'taxPosition_'+securityIndex}>
            <TableContainer component={CardWrapper} className={classes.paper} key={66}>
              <span className={classes.topBar}>
                <p className={classes.title}>{t("TAX_REPORT_TRANSACTION") + ( position.profitLoss > 0 ? ' +' : '') + ' ' + formatNumber(position.profitLoss) + ' ' + position.buy.currency}</p>
              </span>
              <Table className={classes.table} size="small">
                <TableHead className={classes.tableHead}>
                  <TableRow>
                    <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenFirst])}>
                      <p className={classes.tableHeadChildrenText}>{t('FIRST_NAME')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('SURNAME')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('PORTFOLIO')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('TRADE_DATE')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('VALUE_DATE')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('DEAL_TYPE')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('ISIN')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('TICKER')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('QUANTITY')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('QUANTITY_FILL')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('FEE')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('CURRENCY')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('AMOUNT')}</p>
                    </TableCell>
                    <TableCell className={classes.tableHeadChildren}>
                      <p className={classes.tableHeadChildrenText}>{t('TAX_FREE')}</p>
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                    <TableRow >
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.firstName}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.surname}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.portfolio}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.tradeDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.valueDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.tradeType}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.isin}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.ticker}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(position.buy.quantity)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(position.buy.quantityFill)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(position.buy.fee)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{position.buy.currency}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(position.buy.amount)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}></TableCell>
                    </TableRow>
                    { position.sells.length > 0 && (
                      position.sells.map((deal: ClientTaxPositionDeal, index: number) => (
                    <React.Fragment key={index+'_inner'}>
                      <TableRow
                        className={classes.tableRow}
                      >
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.firstName}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.surname}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.portfolio}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.tradeDate}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.valueDate}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.tradeType}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.isin}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{position.buy.ticker}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{formatNumber(deal.quantity)}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{formatNumber(deal.quantityFill)}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{formatNumber(deal.fee)}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{deal.currency}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{formatNumber(deal.amount)}</p>
                        </TableCell>
                        <TableCell className={classes.tableContent}>
                          <p className={classes.text}>{t(deal.freeTax?'YES':'NO')}</p>
                        </TableCell>

                      </TableRow>
                    </React.Fragment>
                  )))}
                </TableBody>
              </Table>
            </TableContainer>
          </React.Fragment>
      ))}

      {!loading && clientTaxWithholdingTaxes && clientTaxWithholdingTaxes.length > 0 &&
        <React.Fragment key={'withHolding_01'}>
          <TableContainer component={CardWrapper} className={classes.paper} key={66}>
            <span className={classes.topBar}>
              <p className={classes.title}>{t("WITHHOLDING_TAXES")}</p>
            </span>
            <Table className={classes.table} size="small">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenFirst])}>
                    <p className={classes.tableHeadChildrenText}>{t('FIRST_NAME')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('SURNAME')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('PORTFOLIO')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('AMOUNT')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('CURRENCY')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('TRADE_DATE')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('VALUE_DATE')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('TEXT')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('DESCRIPTION')}</p>
                  </TableCell>
                  <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenLast])} />
                </TableRow>
              </TableHead>
              <TableBody>
                {clientTaxWithholdingTaxes.map((clientDeal: ClientCashflow, index: number) => (
                  <React.Fragment key={index}>
                    <TableRow
                      className={classNames(index === 0 ? classes.firstClickableRow : classes.tableRow)}
                    >
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.firstName}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.surname}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.portfolio}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(clientDeal.amount)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.currency}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.tradeDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.valueDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.text}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.tpid}</p>
                      </TableCell>

                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      }

      {!loading && clientTaxOtherOperations && clientTaxOtherOperations.length > 0 &&
        <React.Fragment key={'otherOperation_01'}>
          <TableContainer component={CardWrapper} className={classes.paper} key={66}>
            <span className={classes.topBar}>
              <p className={classes.title}>{t("OTHER_OPERATIONS")}</p>
            </span>
            <Table className={classes.table} size="small">
              <TableHead className={classes.tableHead}>
                <TableRow>
                  <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenFirst])}>
                    <p className={classes.tableHeadChildrenText}>{t('FIRST_NAME')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('SURNAME')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('PORTFOLIO')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('AMOUNT')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('CURRENCY')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('TRADE_DATE')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('VALUE_DATE')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('TEXT')}</p>
                  </TableCell>
                  <TableCell className={classes.tableHeadChildren}>
                    <p className={classes.tableHeadChildrenText}>{t('DESCRIPTION')}</p>
                  </TableCell>
                  <TableCell className={classNames([classes.tableHeadChildren, classes.tableHeadChildrenLast])} />
                </TableRow>
              </TableHead>
              <TableBody>
                {clientTaxOtherOperations.map((clientDeal: ClientCashflow, index: number) => (
                  <React.Fragment key={index}>
                    <TableRow
                      className={classNames(index === 0 ? classes.firstClickableRow : classes.tableRow)}
                    >
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.firstName}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.surname}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.portfolio}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{formatNumber(clientDeal.amount)}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.currency}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.tradeDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.valueDate}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.text}</p>
                      </TableCell>
                      <TableCell className={classes.tableContent}>
                        <p className={classes.text}>{clientDeal.tpid}</p>
                      </TableCell>

                    </TableRow>
                  </React.Fragment>
                ))}
              </TableBody>
            </Table>
          </TableContainer>
        </React.Fragment>
      }

      <OrderDetailDialog />
      <FileImportDialog />
      <AlertMessageConfirmation
        alertOpen={showConfirmation}
        onOk={handleConfirmation}
        onCancle={handleCloseConfirmation}
        alertText={t('TAX_POSITION_EXPORT_MESSAGE')}
      />
    </NewLayout>
  )
}
